import { render, staticRenderFns } from "./DeclaracaoVinculoTab.vue?vue&type=template&id=c06e8fee&scoped=true&"
import script from "./DeclaracaoVinculoTab.vue?vue&type=script&lang=js&"
export * from "./DeclaracaoVinculoTab.vue?vue&type=script&lang=js&"
import style0 from "./DeclaracaoVinculoTab.vue?vue&type=style&index=0&id=c06e8fee&prod&scoped=true&lang=css&"
import style1 from "./DeclaracaoVinculoTab.vue?vue&type=style&index=1&id=c06e8fee&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c06e8fee",
  null
  
)

export default component.exports